export const TOKEN_TYPE = 'token '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
